import { Row } from '@atomic/obj.grid';
import { KanbanLaneShimmer } from '../mol.kanban-lane-shimmer/kanban-lane-shimmer.component';
import { Spacing } from '@atomic/obj.constants';
import React from 'react';
export const KanbanShimmer = ({ rows }) => {
    return (React.createElement(Row, { gap: Spacing.Large }, Array(rows !== null && rows !== void 0 ? rows : 5)
        .fill('')
        .map((_, index) => (React.createElement(KanbanLaneShimmer, { key: index, rowNumber: index })))));
};
